import { LucideImageOff } from 'lucide-react'
import { Alert } from '~/components/ui'
import { cn } from '~/utils'

export function WatermarkedImageDisplay({ className }: { className?: string }) {
  return (
    <Alert
      className={cn(
        'flex h-full w-full flex-col items-center justify-center gap-2 rounded-md text-center',
        className
      )}
      variant="destructive">
      <span>
        <LucideImageOff className="h-10 w-10" />
      </span>

      <h3 className="font-semibold">Watermarked Image Detected</h3>
    </Alert>
  )
}
